
/**
 *  A constant for the zero address.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000"``)
 */
export const ZeroAddress: string = "0x0000000000000000000000000000000000000000";

